module.exports = __webpack_public_path__ + "h5/img/project-introduction.0aa20d9b.jpg";